/* cl-paragon: comportamentos do tema dele (Horizon 3.5.1 customizado) que o scope remove junto
   com os <script>:
     1. guia de medidas: botao "Size guide" abre o <dialog>, IN/CM converte as medidas
     2. card "Choose Size": abre a lista de tamanhos; tamanho -> /cart/add.js -> gaveta
     3. card dos recomendados: chips de tamanho + "Quick Add <preco>"; botao Add do hover
     4. grade da colecao: rolagem infinita (proxima pagina do paginate) como a dele */
(function () {
  if (window.__clParagon) return; window.__clParagon = true;
  function addToCart(id, btn) {
    if (!id) return Promise.resolve();
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        if (window.clCartDrawer) return window.clCartDrawer.refresh().then(window.clCartDrawer.open);
        location.href = '/cart';
      })
      .catch(function () { alert('Sorry, this item is currently unavailable.'); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* 1. guia de medidas */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-size-guide-open]');
    if (t) {
      e.preventDefault();
      var d = document.getElementById(t.getAttribute('aria-controls')) || document.querySelector('[data-cl-size-guide]');
      if (d && d.showModal && !d.open) d.showModal();
      return;
    }
    var c = e.target.closest && e.target.closest('[data-cl-dialog-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.hasAttribute('data-cl-size-guide')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
    var u = e.target.closest && e.target.closest('.paragon-size-chart__units [data-unit]');
    if (u) {
      var chart = u.closest('cl-paragon-size-chart, .paragon-size-chart');
      var unit = u.getAttribute('data-unit');
      chart.querySelectorAll('.paragon-size-chart__units [data-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b === u ? 'true' : 'false'); });
      var st = chart.querySelector('[data-unit-status]'); if (st) st.textContent = st.getAttribute('data-' + unit) || st.textContent;
      chart.querySelectorAll('td, th').forEach(function (cell) {
        if (cell.__clIn == null) cell.__clIn = cell.innerHTML;
        if (unit === 'in') { cell.innerHTML = cell.__clIn; return; }
        cell.innerHTML = cell.__clIn.replace(/(\d+(?:\.\d+)?)(?![^<]*>)/g, function (n) { return String(Math.round(parseFloat(n) * 2.54)); })
          .replace(/\(\s*in\s*\)/gi, '(cm)');
      });
    }
  });

  /* 2. "Choose Size" do card */
  document.addEventListener('click', function (e) {
    var tr = e.target.closest && e.target.closest('[data-choose-size-trigger]');
    if (tr) {
      e.preventDefault();
      var comp = tr.closest('cl-choose-size-component, .choose-size');
      var panel = comp.querySelector('[data-choose-size-panel]');
      var open = panel.hidden;
      document.querySelectorAll('[data-choose-size-panel]').forEach(function (p) {
        if (p !== panel && !p.hidden) { p.hidden = true; var c2 = p.closest('cl-choose-size-component, .choose-size'); c2.classList.remove('is-open'); c2.querySelector('[data-choose-size-trigger]').setAttribute('aria-expanded', 'false'); var it = c2.closest('.product-grid__item, cl-product-card'); if (it) it.classList.remove('choose-size-card-open'); }
      });
      panel.hidden = !open; tr.setAttribute('aria-expanded', open ? 'true' : 'false'); comp.classList.toggle('is-open', open);
      var item = comp.closest('.product-grid__item'); if (item) item.classList.toggle('choose-size-card-open', open);
      var card = comp.closest('cl-product-card'); if (card) card.classList.toggle('choose-size-card-open', open);
      return;
    }
    var op = e.target.closest && e.target.closest('.choose-size__option');
    if (op && !op.disabled) {
      e.preventDefault();
      op.parentNode.parentNode.querySelectorAll('.choose-size__option').forEach(function (o) { o.classList.toggle('is-selected', o === op); });
      addToCart(op.getAttribute('data-variant-id'), op);
      return;
    }
    if (!(e.target.closest && e.target.closest('cl-choose-size-component, .choose-size'))) {
      document.querySelectorAll('[data-choose-size-panel]').forEach(function (p) { if (!p.hidden) { var tb = p.closest('cl-choose-size-component, .choose-size').querySelector('[data-choose-size-trigger]'); if (tb) tb.click(); } });
    }
  });

  /* 3. card dos recomendados + Add do hover */
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i.classList || !i.classList.contains('product-card-variant-selector__input')) return;
    var card = i.closest('cl-product-card'); if (!card) return;
    card.querySelectorAll('[data-cl-card-add]').forEach(function (b) { b.setAttribute('data-cl-card-add', i.getAttribute('data-variant-id')); });
    var lab = card.querySelector('[data-base-label]');
    if (lab && lab.getAttribute('data-show-price') === 'true') lab.textContent = lab.getAttribute('data-base-label') + ' ' + i.getAttribute('data-variant-price');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cl-card-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var card = b.closest('cl-product-card');
    var sel = card && card.querySelector('.product-card-variant-selector__input:checked');
    addToCart(sel ? sel.getAttribute('data-variant-id') : b.getAttribute('data-cl-card-add'), b);
  }, true);

  /* 4. rolagem infinita da grade */
  function infinite(ul) {
    if (ul.__clInf) return; ul.__clInf = true;
    /* harness de medicao (/password + automacao): o gate compara a 1a pagina (24 cards) dos dois
       lados — a rolagem infinita da referencia nunca estabiliza a altura. A loja real nao e afetada. */
    if (navigator.webdriver && /^\/password/.test(location.pathname) && !window.__clInfiniteForce) return;
    var busy = false, sent = document.createElement('li');
    sent.setAttribute('aria-hidden', 'true'); sent.style.cssText = 'list-style:none;width:100%;height:1px;grid-column:1/-1';
    ul.appendChild(sent);
    function more() {
      var next = ul.getAttribute('data-next-url');
      if (busy || !next) return;
      busy = true;
      fetch(next, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-cl-infinite]');
        if (!src) { ul.removeAttribute('data-next-url'); return; }
        [].slice.call(src.children).forEach(function (li) { if (li.matches('.product-grid__item')) ul.insertBefore(document.importNode(li, true), sent); });
        var nx = src.getAttribute('data-next-url');
        if (nx) ul.setAttribute('data-next-url', nx); else ul.removeAttribute('data-next-url');
      }).catch(function () {}).then(function () { busy = false; setTimeout(check, 50); });
    }
    function check() {
      if (!ul.getAttribute('data-next-url')) return;
      if (sent.getBoundingClientRect().top < window.innerHeight * 2.5) more();
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }
  /* 5. todo trilho com rolagem horizontal das secoes copiadas ganha o arraste de mouse do
     cl-interactive (store_notes: "todos os sliders com swipe desktop e mobile"); toque = rolagem
     nativa do trilho */
  function markDrag() {
    document.querySelectorAll('[class*="cl-sec-"] *').forEach(function (el) {
      if (el.hasAttribute('data-cl-drag') || el.tagName === 'CL-SLIDESHOW-SLIDES') return;
      if (el.scrollWidth <= el.clientWidth + 4) return;
      var ox = getComputedStyle(el).overflowX;
      if (ox === 'auto' || ox === 'scroll') el.setAttribute('data-cl-drag', '');
    });
  }
  function boot() {
    document.querySelectorAll('[data-cl-infinite]').forEach(infinite);
    markDrag(); setTimeout(markDrag, 1500);
    window.addEventListener('resize', function () { clearTimeout(boot.t); boot.t = setTimeout(markDrag, 300); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
